<template>
  <model-form
    ref="form"
    :model="membershipUserType"
    :title="`Edit ${membershipUserType.userClass.name} Price for ${membershipUserType.membershipType && membershipUserType.membershipType.name || 'Membership'}`"
    :submodel="true"
    modal-type="modal"
    :handled-actions="['edit']"
  >
    <div class="column">
      <div class="row q-col-gutter-sm items-start">
        <q-input
          v-model="membershipUserType.userClass.name"
          :disable="true"
          class="col-auto"
          :label="$t('user.userClass')"
          :rules="[val => val !== null || 'Field is required']"
          bottom-slots
        />
        <div
          v-if="currentCircuit.membershipRateDisplayPeriod === MEMBERSHIP_RATE_DISPLAY_PERIODS.MONTHLY"
          class="col row q-col-gutter-sm items-start"
        >
          <q-input
            v-model.number="membershipUserType.monthlyRate"
            class="col"
            label="Monthly Rate"
            :prefix="currentCircuit.localeCurrencySymbol"
            type="number"
            step="0.25"
            :rules="[val => val !== null || 'Field is required']"
            bottom-slots
          />
          <q-input
            v-model.number="membershipUserType.additionalMonthlyRate"
            class="col"
            label="Additional Rate"
            :prefix="currentCircuit.localeCurrencySymbol"
            type="number"
            step="0.25"
            :rules="[val => val !== null || 'Field is required']"
            bottom-slots
          />
        </div>
        <div
          v-if="currentCircuit.membershipRateDisplayPeriod === MEMBERSHIP_RATE_DISPLAY_PERIODS.YEARLY"
          class="col row q-col-gutter-sm items-start"
        >
          <q-input
            :model-value="membershipUserType.yearlyRate"
            class="col"
            label="Yearly Rate"
            :prefix="currentCircuit.localeCurrencySymbol"
            type="number"
            step="0.25"
            :rules="[val => val !== null || 'Field is required']"
            bottom-slots
            @update:model-value="val => membershipUserType.yearlyRate = Math.round(Number(val || 0) * 100.0) / 100.0"
          />
          <q-input
            :model-value="membershipUserType.additionalYearlyRate"
            class="col"
            label="Additional Rate"
            :prefix="currentCircuit.localeCurrencySymbol"
            type="number"
            step="0.25"
            :rules="[val => val !== null || 'Field is required']"
            bottom-slots
            @update:model-value="val => membershipUserType.additionalYearlyRate = Math.round(Number(val || 0) * 100.0) / 100.0"
          />
        </div>
      </div>
    </div>
  </model-form>
</template>

<script>

import { MEMBERSHIP_RATE_DISPLAY_PERIODS } from 'src/models/circuit/Circuit'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'MembershipUserTypeForm',
  components: {
    ModelForm
  },
  configuration: ['currentCircuit'],
  models: {
    membershipUserType: 'default'
  },
  created () {
    _.extend(this, { MEMBERSHIP_RATE_DISPLAY_PERIODS })
  }
}

</script>
